import { brandAssets } from '../lib/brandAssets';
import { useTheme } from '../theme/ThemeProvider';

type BrandWordmarkProps = {
  className?: string;
};

/** Canonical GhostScreens wordmark — invert on dark theme. */
export function BrandWordmark({ className = '' }: BrandWordmarkProps) {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <img
      src={brandAssets.wordmark}
      alt="GhostScreens"
      draggable={false}
      className={[
        'w-auto select-none object-contain object-left rtl:object-right',
        className.includes('h-') ? '' : 'h-6',
        className.includes('max-w-') ? '' : 'max-w-[168px]',
        isDark ? 'brightness-0 invert' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
